import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { IoIosSave } from "react-icons/io";
import { IoCloseSharp, IoPrintSharp } from "react-icons/io5";
import {
  calculateAge,
  deepCopy,
  modifyString,
  print,
} from "../../_helper/utils/utils";
// import html2canvas from "html2canvas";
import ReactToPrint from "react-to-print";
import moment from "moment";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
// import { useCurrentRole } from "../../_helper/constant/Permission";
import "../css/PrintPreview.css";
import { pageSizes } from "../../doctor_setup/constants/_constant";
import { getImageURL } from "../../_helper/utils/image";
import CuInput from "../../all-patient/components/CuInput";
// import { prescriptionSetupAtom } from "../constants/_constant";

const keys = ["frequency", "when", "duration", "notes"];

const PrintPreview = ({
  data,
  userDetails,
  allergies,
  addictions,
  closeModal,
  patientHistory,
}) => {
  const printContentRef = useRef(null);
  // const [previewImage, setPreviewImage] = useState(null);
  const [clinic] = useAtom(clinicAtom);
  const [translateQuery, setTranslateQuery] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("eng");
  const [fontsize, setFontSize] = useState(14);
  const [translatedConsultationData, setTranslatedConsultationData] =
    useState(null);
  const reactToPrintRef = useRef(null); // Reference to the ReactToPrint component

  const filterByTagType = (data, tagType) => {
    return data?.filter((item) => item?.tag_type?.includes(tagType));
  };

  //("Print Data", data);

  const sequence = [
    "Complaints",
    "Allergies",
    "Vitals",
    "Patient history",
    "Diagnosis",
    "Medicine details",
    "Advice & directions",
    "Test & investigation",
  ];

  const [{ prescription_setup: settings, header_footer_setup }] =
    useAtom(doctorSettingAtom);

  const { data: languages } = useItemsFilter(
    ApiEndPoint.QP_CM_LANGUAGE,
    `?action=getLanguages&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id ? true : false
  );

  const { data: translatedData } = useItemsFilter(
    ApiEndPoint.TRANSLATION,
    `?action=getCustomTranslationValues&clinic_id=${clinic?.id}&backend=True${translateQuery}`,
    clinic?.id && translateQuery?.length > 0 ? true : false
  );

  useEffect(() => {
    if (translatedData) {
      //replace original data with translated data
      const translatedConsultation = deepCopy(data);

      for (let i of translatedConsultation?.medicine_data) {
        for (let j of keys) {
          if (j !== "duration") {
            if (i[j]?.name) {
              const existingIndex = translatedData?.findIndex(
                (tdta) => tdta?.translation_name === i[j]?.name
              );
              if (existingIndex > -1) {
                i[j].name = translatedData[existingIndex]?.value;
              }
            }
          } else {
            const existingIndex = translatedData?.findIndex(
              (tdta) => tdta?.translation_name === i[j]
            );
            if (existingIndex > -1) {
              i[j] = translatedData[existingIndex]?.value;
            }
          }
        }
      }
      setTranslatedConsultationData(translatedConsultation);
      setTranslateQuery("");
    }
  }, [translatedData]);

  const generateTranslationQuery = (id) => {
    const filterArray = [];
    for (let i of data?.medicine_data) {
      for (let j of keys) {
        if (j !== "duration") {
          if (i[j]?.name) filterArray.push(i[j]?.name?.toUpperCase());
        } else {
          filterArray.push(i[j]);
        }
      }
    }

    setTranslateQuery(
      `&language=${id}&custom_translation=${JSON.stringify(filterArray)}`
    );
  };

  const handleLanguageChange = (langId) => {
    generateTranslationQuery(langId);
    setSelectedLanguage(langId);
  };

  const getVitalToRender = (vitalData) => {
    let vital = "";
    const count = vitalData?.type?.no_of_fields;
    const seperator = vitalData?.type?.seperator;
    let result = [];

    for (let i = 1; i <= count; i++) {
      vital += `${vitalData[`value${i}`]} ${i === count ? "" : seperator} `;
    }

    result.push(
      <span key={vitalData?.id}>{`${vital} ${vitalData?.selected_unit}`}</span>
    );

    if (vitalData?.type?.label?.toLowerCase() === "bp") {
      const readings =
        vitalData?.reading?.map((ele, idx) => (
          <span key={`${idx}-${ele?.value1}-${ele?.value2}`}>{`${
            ele?.value1
          } / ${ele?.value2} ${ele?.valueUnit} (${moment(ele?.timeStamp).format(
            "DD MMMM YYYY hh:mm A"
          )})`}</span>
        )) || [];
      result = [...result, ...readings];
    }

    return result;
  };

  const renderSection = (sectionTitle, consultationData, tagId) => {
    const filteredTags =
      filterByTagType(consultationData?.qp_cm_consultation_tags, tagId) || [];

    const matchText = modifyString(sectionTitle, true);

    //("matchtext--------", matchText);

    switch (matchText) {
      case "COMPLAINTS":
        if (filteredTags?.length > 0) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[14%]">
                {sectionTitle}
              </div>
              <div className="flex flex-wrap gap-1">
                {filteredTags?.map((ele, ind) => (
                  <div
                    key={`${ele?.id}-${ind}`}
                    className={`text-gray-600 font-light`}
                  >
                    {`${ind === 0 ? "-" : ""}${ele?.name}${
                      ele?.remark ? ` (since ${ele?.remark})` : ""
                    }${ind === filteredTags?.length - 1 ? "" : ","}`}
                  </div>
                ))}
              </div>
            </section>
          );
        }
        break;

      case "VITALS":
        const hasVitals = consultationData?.qp_cm_vitals?.some(
          (vital) =>
            (vital?.value1 && vital?.value1 !== 0) ||
            (vital?.value2 && vital?.value2 !== 0) ||
            (vital?.value3 && vital?.value3 !== 0)
        );

        if (hasVitals) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[14%]">
                {sectionTitle}
              </div>
              <div className="flex flex-wrap gap-10">
                {consultationData?.qp_cm_vitals?.map((ele, ind) => {
                  // Only include vitals with valid non-zero values
                  if (
                    (ele?.value1 && ele?.value1 !== 0) ||
                    (ele?.value2 && ele?.value2 !== 0) ||
                    (ele?.value3 && ele?.value3 !== 0)
                  ) {
                    return (
                      <div
                        className="flex flex-col gap-1"
                        key={`${ele?.id}-${ind}`}
                      >
                        <span className="cu-print-preview-vital-label">
                          {ele?.type?.label}
                        </span>
                        <span className="cu-print-preview-vital-value">
                          {/* Show value1, value2, value3 if they are non-zero */}
                          {ele?.value1 ? `${ele?.value1}` : ""}
                          {ele?.value2
                            ? `${ele?.separator || "/"}${ele?.value2}`
                            : ""}
                          {ele?.value3
                            ? `${ele?.separator || "/"}${ele?.value3}`
                            : ""}
                          {ele?.selected_unit ? ` ${ele?.selected_unit}` : ""}
                        </span>
                      </div>
                    );
                  }
                  return null; // Skip rendering if all values are 0 or falsy
                })}
              </div>
            </section>
          );
        }

        break;
      case "ALLERGY":
        if (allergies && allergies?.length > 0) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className={`text-gray-600 font-light w-[14%]`}>
                Allergies
              </div>
              <div className="flex gap-2 items-center">
                {allergies?.map((ele, ind) => (
                  <div
                    key={`${ele?.id}-${ind}`}
                    className={`text-gray-600 font-light`}
                  >
                    {`${ind === 0 ? "-" : ""}${ele?.name}${
                      ind === allergies?.length - 1 ? "" : ","
                    }`}
                  </div>
                ))}
              </div>
            </section>
          );
        }

        break;

      case "PATIENTHISTORY":
        if (patientHistory && patientHistory?.length > 0) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[14%]">
                Patient history
              </div>

              <div className="flex gap-2 items-center">
                {patientHistory?.map((ele, ind) => (
                  <div key={`${ele?.id}-${ind}`} className={`text-gray-600 `}>
                    {`${ind === 0 ? "-" : ""}${ele?.name}${
                      ind === patientHistory?.length - 1 ? "" : ","
                    }`}
                  </div>
                ))}
              </div>
            </section>
          );
        }
        break;

      case "DIAGNOSIS":
        if (filteredTags?.length > 0) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[14%]">Diagnosis</div>
              <div className="flex gap-2 items-center">
                {filteredTags?.map((ele, ind) => (
                  <div
                    key={`${ele?.id}-${ind}`}
                    className={`text-gray-600 font-light`}
                  >
                    {`${ind === 0 ? "-" : ""}${ele?.name}${
                      ind === filteredTags?.length - 1 ? "" : ","
                    }`}
                  </div>
                ))}
              </div>
            </section>
          );
        }
        break;
      case "MEDICINEDETAILS":
        if (
          consultationData?.medicine_data &&
          consultationData?.medicine_data?.length > 0
        ) {
          return (
            <div className="overflow-x-auto border-b pt-4">
              <div>
                <span style={{ fontSize: `${fontsize || 16}px` }}>R</span>
                <span style={{ fontSize: `${fontsize ? fontsize / 2 : 8}px` }}>
                  x
                </span>
              </div>
              <table
                className="min-w-full table-auto text-sm text-left"
                style={{ fontSize: fontsize ? `${fontsize}px` : "inherit" }}
              >
                <thead
                  className="text-xs text-gray-600 border uppercase bg-white"
                  style={{
                    fontSize: fontsize ? `${fontsize - 2}px` : "inherit",
                  }}
                >
                  <tr>
                    <th scope="col" className="px-6 py-1">
                      No
                    </th>
                    <th scope="col" className="px-6 py-1">
                      Medicine Name
                    </th>
                    <th scope="col" className="px-6 py-1">
                      Dose
                    </th>
                    <th scope="col" className="px-6 py-1">
                      Duration
                    </th>
                    <th scope="col" className="px-6 py-1">
                      Remark
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {consultationData?.medicine_data?.map((ele, ind) => (
                    <tr
                      key={`${ele?.id}-${ind}`}
                      className="bg-white border-b"
                      style={{
                        fontSize: fontsize ? `${fontsize}px` : "inherit",
                      }}
                    >
                      <td className="px-6 py-0">{ind + 1}</td>
                      <td className="px-6 py-0">
                        <span className="font-bold text-gray-800">
                          {ele?.medicineName}
                        </span>
                        <br />
                        <span className="font-light text-gray-600">
                          {ele?.genericName?.name}
                        </span>
                      </td>
                      <td className="px-6 py-0">
                        {ele?.dosage?.name}
                        <span className="font-light text-xs ml-1">
                          ({ele?.when?.name})
                        </span>
                      </td>
                      <td className="px-6 py-0">
                        {ele?.duration}
                        <span className="font-light text-xs ml-1">
                          ({ele?.frequency?.name || "-"})
                        </span>
                      </td>
                      <td className="px-6 py-0">{ele?.notes?.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        break;

      case "ADVICE&DIRECTION":
        if (consultationData?.qp_cm_advices?.description) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[16%]">
                Advice & directions
              </div>
              <div className="text-gray-600 font-light">
                -{consultationData?.qp_cm_advices?.description}
              </div>
            </section>
          );
        }

        break;
      case "TEST&INVESTIGATION":
        if (filteredTags?.length > 0) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[16%]">
                Test & Investigation
              </div>
              <div className="flex gap-2 items-center">
                {filteredTags?.map((ele, ind) => (
                  <div
                    key={`${ele?.id}-${ind}`}
                    className="text-gray-600 font-light"
                  >
                    {`${ind === 0 ? "-" : ""}${ele?.name}${
                      ind === filteredTags?.length - 1 ? "" : ","
                    }`}
                  </div>
                ))}
              </div>
            </section>
          );
        }

        break;

      case "OBSERVATION":
        if (data?.observation) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[16%]">
                Observation:-
              </div>
              <div className="text-gray-600 font-light">
                {data?.observation}
              </div>
            </section>
          );
        }
        break;

      case "NEXTVISIT":
        if (data?.next_visit_date) {
          return (
            <section className="flex items-center border-b pt-4">
              <div className="text-gray-600 font-light w-[16%]">
                Next visit Date:-
              </div>
              <div className="text-gray-600 font-light">
                {moment(data?.next_visit_date, "YYYY-MM-DD").format(
                  "MMMM D, YYYY"
                )}
              </div>
            </section>
          );
        }
        break;

      default:
        return null;
    }
  };

  const bodyHeightInCm =
    Number(pageSizes[settings?.pageSize]?.height) -
    (Number(header_footer_setup[settings?.pageSize]?.headerHeight) +
      Number(header_footer_setup[settings?.pageSize]?.footerHeight) +
      Number(settings?.signatureHeight));

  // useEffect(() => {
  //   // Automatically trigger print if screen width is small
  //   const screenWidth = window.innerWidth;
  //   if (screenWidth < 768 && reactToPrintRef.current) {
  //     reactToPrintRef.current.handlePrint(); // Trigger the print functionality
  //   }
  // }, []);

  // Function to calculate available content height dynamically
  const calculateContentHeight = () => {
    const pageHeight = 29.7; // Default A4 height
    const headerHeight =
      header_footer_setup[settings?.pageSize]?.headerHeight || 0;
    const footerHeight =
      header_footer_setup[settings?.pageSize]?.footerHeight || 0;
    const totalMargin = settings?.marginTop + settings?.marginBottom;

    // Subtract header, footer, and margins from page height
    return pageHeight - headerHeight - footerHeight - totalMargin;
  };

  // Function to calculate body height for main content
  const calculateBodyHeight = () => {
    const headerHeight =
      header_footer_setup[settings?.pageSize]?.headerHeight || 0;
    const footerHeight =
      header_footer_setup[settings?.pageSize]?.footerHeight || 0;

    return calculateContentHeight() - headerHeight - footerHeight;
  };

  const onChange = (e) => {
    setFontSize(e.target.value);
  };

  return (
    <>
      <div className="flex justify-end gap-3 items-center border-b pb-2">
        <div className="flex items-center gap-2">
          <label className="text-sm font-medium text-gray-700">Font size</label>
          <input
            type="number"
            className="border border-gray-300 rounded px-2 py-1 w-16 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            onChange={onChange}
            value={fontsize}
            placeholder="12" // Example placeholder, set it if needed
          />
          <span className="text-sm text-gray-500">px</span>
        </div>
        <div>
          <select
            className="border"
            onChange={(e) => handleLanguageChange(e.target.value)}
            value={selectedLanguage}
          >
            {languages?.map((ele) => (
              <option key={ele?.id} value={ele?.id}>
                {ele?.name}
              </option>
            ))}
            <option value={"eng"}>{"English"}</option>
          </select>
        </div>
        <ReactToPrint
          // ref={reactToPrintRef} // Attach the ref here
          documentTitle="Precription"
          trigger={() => <IoPrintSharp size={23} className="cursor-pointer" />}
          content={() => printContentRef.current}
          pageStyle={`
  @page {
      size: ${settings?.pageSize || "A4"};
      margin: ${settings?.marginTop || 2}cm ${settings?.marginRight || 1}cm ${settings?.marginBottom || 2}cm ${settings?.marginLeft || 1}cm;
 
    }




    /* Ensure header and footer are fixed on every page */
    .print-header {
      position: absolute; /* Use fixed to keep header at the top of each page */
      left: 0;
      right: 0;
      width: 100%;
      z-index: 100;
      top: 0; /* Place header at the top */
      height: ${header_footer_setup[settings?.pageSize]?.headerHeight || 2}cm; /* Header height */
    }

    /* Ensure footer is placed at the bottom of every page */
    .print-footer {
      position: fixed; /* Use fixed to keep footer at the bottom of each page */
      display: block;
      left: 0;
      right: 0;
      bottom: 0; /* Align it to the bottom */
      width: 100%;
      height: ${header_footer_setup[settings?.pageSize]?.footerHeight || 2}cm; /* Footer height */
      
    }

    /* Body content margin to avoid overlap with footer */
    .print-body {
      padding-top: ${header_footer_setup[settings?.pageSize]?.headerHeight}cm; /* Space for header */
    
    }

    /* Ensure content doesn't overlap with footer */
    @page {
      @bottom-center {
        content: element(footer);
      }
    }

   @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
     
  }


  `}
        />
        {/* <IoIosSave size={18} className="cursor-pointer" /> */}
        <IoCloseSharp
          size={23}
          onClick={() => closeModal()}
          className="cursor-pointer"
        />
      </div>

      <div
        style={{
          height: `${calculateContentHeight()}cm`, // Dynamically calculated height
          width: `${pageSizes[settings?.pageSize]?.width}cm`,
          fontSize: fontsize ? `${fontsize}px` : "inherit", // Apply fontsize dynamically
        }}
        ref={printContentRef}
      >
        {/* Header */}
        <table className="print-component">
          <thead>
            <div className="print-header">
              <img
                src={getImageURL(
                  header_footer_setup[settings?.pageSize]?.headerUrl
                )}
                alt="header"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          </thead>
          {/* Body Content */}
          <tbody>
            <div
              className="print-body"
              style={
                {
                  // marginTop: `${header_footer_setup[settings?.pageSize]?.headerHeight || 2}cm`,
                  // marginBottom: `${header_footer_setup[settings?.pageSize]?.footerHeight || 2}cm`,
                }
              }
            >
              <div className="flex justify-between pt-2 pb-1">
                <div className="flex items-center gap-3 font-bold text-gray-600">
                  <span>{userDetails[0]?.full_name}</span>
                  <span>
                    {calculateAge(userDetails[0]?.dob).years !== 0
                      ? `${calculateAge(userDetails[0]?.dob).years} Yrs`
                      : calculateAge(userDetails[0]?.dob).months !== 0
                        ? `${calculateAge(userDetails[0]?.dob).months} M`
                        : `${calculateAge(userDetails[0]?.dob).days} D`}
                  </span>
                  <span>{userDetails[0]?.gender}</span>
                  <span>{userDetails[0]?.phone}</span>
                </div>
                <div>{`Visit Date :- ${moment().format("MMMM D, YYYY")}`}</div>
              </div>
              {settings?.pageOrdering?.map((sectionTitle, idx) => (
                <div key={`${idx}-${sectionTitle}`}>
                  {renderSection(
                    sectionTitle?.label,
                    selectedLanguage === "eng"
                      ? data
                      : translatedConsultationData,
                    sectionTitle?.tagId
                  )}
                </div>
              ))}
            </div>
          </tbody>
          <tfoot>
            {header_footer_setup[settings?.pageSize]?.printSignature && (
              <div>
                <div
                  className=" flex flex-col items-end overflow-hidden m-0 p-0"
                  style={{
                    height: `${header_footer_setup[settings?.pageSize]?.signatureHeight}cm`,
                  }}
                >
                  <div
                    style={{
                      width: `${header_footer_setup[settings?.pageSize]?.signatureWidth}cm`,
                    }}
                    className="m-0 p-0"
                  >
                    <img
                      src={getImageURL(
                        header_footer_setup[settings?.pageSize]?.signatureImg
                      )}
                      className="m-0 p-0"
                      alt="..."
                    />
                    {header_footer_setup[settings?.pageSize]?.signatureText
                      ?.split("\n")
                      .map((line, index) => (
                        <div key={index}>{line}</div>
                      ))}
                  </div>
                </div>
                {/* <div className="page-break" /> */}
              </div>
            )}

            {/* Footer always at the bottom */}

            <div id="footer">
              {header_footer_setup[settings?.pageSize]?.footerHeight > 0 && (
                <>
                  <div id="footer" className="print-footer">
                    <img
                      src={getImageURL(
                        header_footer_setup[settings?.pageSize]?.footerUrl
                      )}
                      alt="footer"
                      className="h-full w-full"
                    />
                  </div>
                </>
              )}
            </div>
            {/* <div className="text-sm">Cufront Healthcare</div> */}
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default PrintPreview;
